import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

export default function AuthorCard() {
  return (
    <Reveal>
      <aside className="rounded-sm border hairline bg-white p-7 md:p-9 flex flex-col sm:flex-row items-start gap-7" data-testid="author-card">
        <img src="/images/majdi-zarougui.jpg" alt="Majdi Zarougui — Expert Industrialisation & Excellence Opérationnelle"
          className="w-24 h-24 md:w-28 md:h-28 rounded-full object-cover object-top border hairline shrink-0" loading="lazy" />
        <div className="flex-1">
          <span className="label-mono text-gold">À propos de l'auteur</span>
          <h3 className="font-display text-2xl font-semibold mt-2">Majdi Zarougui</h3>
          <p className="text-ink/55 text-sm mt-2 leading-relaxed max-w-2xl">
            Expert Industrialisation &amp; Excellence Opérationnelle — Lean Manufacturing, Lean Six Sigma Green Belt,
            TWI et performance industrielle. Fondateur de NovaLean Consulting.
          </p>
          <Link to="/majdi-zarougui" data-testid="author-card-profile-link"
            className="group inline-flex items-center gap-2 mt-5 label-mono text-ink link-underline">
            Voir le profil <ArrowUpRight size={15} className="group-hover:rotate-45 transition-transform" />
          </Link>
        </div>
      </aside>
    </Reveal>
  );
}
